const actions = {
    UPDATE_USER_INFO:"UPDATE_USER_INFO",
    UPDATE_USER_METERS:"UPDATE_USER_METERS",
    UPDATE_LOADING:"UPDATE_LOADING",
    SHOW_ERROR_MESSAGE:"SHOW_ERROR_MEESAGE",
    SHOW_SUCCESS_MESSAGE:"SHOW_SUCCESS_MESSAGE",
    LOGOUT:"LOGOUT",
    SET_ACCESS_TOKEN:"SET_ACCESS_TOKEN"
    
};

export default actions;